"use strict";
exports.__esModule = true;
exports["default"] = {};
//# sourceMappingURL=libcore-postSyncPatch.js.map